module.exports = __webpack_public_path__ + "static/media/taylor1.fbd381fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/taylor1.jpg
// module id = 98
// module chunks = 0